<template>
  <div class="vessel-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex" v-if="$store.state.userInfo.type === 'A'">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            @click.prevent="exportCsv()"
            class="btn-color ml-4"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="mb-6 filter-card" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.owner") }}</label>
          <v-select
            v-model="owner"
            :options="owners"
            :reduce="(owners) => owners.id"
            name="owner"
            :value="$store.myValue"
            @input="setSelectedOwner"
            label="name"
            :clearable="false"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.manager") }}</label>
          <v-select
            v-model="manager"
            :options="managers"
            name="manager"
            :reduce="(managers) => managers.id"
            label="name"
            :clearable="false"
          />
        </div>

        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.office") }}</label>
          <v-select
            v-model="office"
            :options="offices"
            name="office"
            :reduce="(offices) => offices.id"
            label="name"
            :clearable="false"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.fleet") }}</label>
          <v-select
            v-model="fleet"
            :options="fleets"
            name="fleet"
            :reduce="(fleets) => fleets.id"
            label="name"
            :clearable="false"
          />
        </div>

        <div class="vx-col sm: w-full md:w-1/3 flex">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="
              !this.search &&
              !this.owner &&
              !this.manager &&
              !this.office &&
              !this.fleet
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="
              !this.search &&
              !this.owner &&
              !this.manager &&
              !this.office &&
              !this.fleet
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.vessel_detail')">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.projects") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddVessel' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('vessel', 'add')"
              >{{ $t("labels.add_vessel") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="vessels" class="vessel-listing permission">
        <template slot="thead">
          <vs-th class="col-md-3">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-4">{{ $t("labels.type") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.flag") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            v-bind:class="[tr.is_active != 1 ? 'user-table' : '']"
          >
            <vs-td :data="tr.name">
              <router-link
                class="view-link"
                :to="{ name: 'ViewVessel', params: { id: tr.id } }"
                v-if="checkPermission('vessel', 'view')"
                >{{ tr.name }}</router-link
              >
            </vs-td>
            <vs-td :data="tr.name"
              >{{ tr.type ? tr.type.name : "-" }}
              {{ tr.sub_type ? "(" + tr.sub_type.name + ")" : "" }}
            </vs-td>
            <vs-td :data="tr.name">{{ tr.flag ? tr.flag.name : "-" }}</vs-td>
            <vs-td class="pl-0" width="220">
              <div class="flex">
                <router-link
                  class="view-link"
                  :to="{ name: 'ViewVessel', params: { id: tr.id } }"
                  v-if="checkPermission('vessel', 'view')"
                >
                  <vs-button
                    type="flat"
                    :title="$t('labels.view')"
                    size="large"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="mr-2"
                    color="dark"
                  ></vs-button>
                </router-link>
                <router-link
                  class="view-link"
                  :to="{ name: 'EditVessel', params: { id: tr.id } }"
                  v-if="checkPermission('vessel', 'modify')"
                >
                  <vs-button
                    type="flat"
                    :title="$t('labels.edit')"
                    size="large"
                    icon-pack="feather"
                    icon="icon-edit"
                    color="success"
                    class="mr-2"
                  ></vs-button>
                </router-link>

                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  v-if="checkPermission('vessel', 'delete')"
                  color="danger"
                >
                </vs-button>
                <vs-button
                  @click="blockConfirm(indextr)"
                  type="flat"
                  :title="
                    !tr.is_active ? $t('labels.active') : $t('labels.deactive')
                  "
                  size="large"
                  icon-pack="feather"
                  :icon="!tr.is_active ? 'icon-unlock' : 'icon-lock'"
                  :color="!tr.is_active ? 'dark' : 'warning'"
                  v-if="checkPermission('vessel', 'modify')"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";
import vSelect from "vue-select";
export default {
  components: {
    KeyIcon,
    vSelect,
  },
  data() {
    return {
      vessels: [],
      totalPage: 1,
      currentx: 1,
      // limit: parseInt(process.env.VUE_APP_PER_PAGE),
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
      owner: 0,
      manager: 0,
      office: 0,
      fleet: 0,
      owners: [],
      managers: [],
      offices: [],
      fleets: [],
      selected_owner: "",
    };
  },
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getVessels();
    },
    currentx() {
      this.getVessels();
    },
    owner(value) {
      if (value === 0 || value === "") {
        this.manager = 0;
        this.managers = [];
      } else {
        this.getManagers();
      }
    },
    manager(value) {
      if (value === 0 || value === "") {
        this.office = 0;
        this.offices = [];
      } else {
        this.getOffices();
      }
    },
    office(value) {
      if (value === 0 || value === "") {
        this.fleet = 0;
        this.fleets = [];
      } else {
        this.getFleets();
      }
    },
    // fleet(value) {
    //   this.getVessels();
    // }
  },
  computed: {},
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getVessels();
    //this.getOwners();
  },
  methods: {
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteVessel,
      });
    },
    async deleteVessel() {
      if (this.index < 0) return;
      let url = "vessels/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.vessels[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getVessels();
      }
    },
    // async getOwners() {
    //   var input = {
    //     type: "CL",
    //     sub_type: "OW"
    //   };
    //   let response = await this.getHTTPPostResponse("/users", input);
    //   if (response) {
    //     let data = response.data.users;
    //     this.owners = data;
    //   }
    // },
    async getManagers() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.owner);
      if (response) {
        let user = response.data.user;
        this.managers = user.children;
      }
    },
    async getOffices() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.manager
      );
      if (response) {
        let user = response.data.user;
        this.offices = user.children;
      }
    },
    async getFleets() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.office);
      if (response) {
        let user = response.data.user;
        this.fleets = user.children;
      }
    },
    setSelectedOwner(value) {
      //fist clear selected manager and its dropdown array
      this.manager = 0;
      this.managers = [];
      //set current v -select value as a selected_owner
      this.selected_owner = value;

      // get managers for selected owner
      let owners = this.owners;
      var slected_owners = owners.filter(function (el) {
        return el.id == value;
      });
      let manager_req = this.managers;
      let filteredManagers = [];
      for (var i = 0; i < manager_req.length; i++) {
        let obj = { id: manager_req[i].id, name: manager_req[i].name };
        filteredManagers.push(obj);
      }
      this.managers = filteredManagers;
    },
    async getVessels(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        client_id: this.fleet || this.office || this.manager || this.owner,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/vessels/list", input);
      if (exp) {
        this.exportFile(response, "Vessels");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let vessels = data.vessels;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.vessels = vessels;
        }
      }
    },
    exportCsv() {
      this.getVessels(true);
    },
    filter() {
      this.getVessels();
    },
    clearFilter() {
      this.search = null;
      this.fleet = 0;
      this.office = 0;
      this.manager = 0;
      this.owner = 0;
      this.getVessels();
    },
    blockConfirm(index) {
      this.index = index;
      let text;
      let is_active = this.vessels[index].is_active;
      let title;
      if (is_active) {
        text = this.$t("strings.deactive_confirm");
        title = this.$t("labels.deactive");
      } else {
        text = this.$t("strings.active_confirm");
        title = this.$t("labels.active");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: title,
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: text,
        accept: this.updateStatus,
      });
    },
    async updateStatus() {
      if (this.index < 0) return;
      let index = this.index;
      let ids = [];
      ids.push(this.vessels[index].id);
      let is_active = this.vessels[index].is_active;

      let input = {
        is_active: !is_active,
        ids: ids,
      };
      let url = "/vessels/change-status";
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.index = -1;
        this.getVessels();
      }
    },
  },
};
</script>
